import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.materials.new');
import { OnInit, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import * as pdfjsLib from 'pdfjs-dist/build/pdf.mjs';

interface AutoDraftCandidate {
    field: string;
    label: string;
    value: string;
    source: string;
    status: string;
    applied?: boolean;
    reviewValue?: string;
    note?: string;
    updatedAt?: string;
    sourceKind?: string;
    sourceKey?: string;
    stale?: boolean;
}

interface UrlAnalysisResult {
    accessible?: boolean;
    statusCode?: number;
    inputUrl?: string;
    finalUrl?: string;
    contentType?: string;
    pageTitle?: string;
    originalLink?: string;
    pdfLinks?: any[];
    coverImages?: any[];
    metadataCandidates?: any[];
    candidates?: AutoDraftCandidate[];
    message?: string;
    resourceType?: string;
    failureType?: string;
    redirected?: boolean;
    redirects?: any[];
    fetchLimitBytes?: number;
}

interface MaterialRegistrationForm {
    submissionId: string;
    saveIntent: string;
    materialIdMode: string;
    materialId: string;
    autoGenerationBasis: string;
    title: string;
    materialType: string;
    contributor: string;
    publicationInfo: string;
    source: string;
    publisher: string;
    publishedYear: string;
    seriesTitle: string;
    externalIdentifier: string;
    originalUrl: string;
    externalViewUrl: string;
    sourceLink: string;
    fileNote: string;
    storageStatus: string;
    textExtractionStatus: string;
    fileMetadata: any;
    fileNameAnalysis: string;
    pdfMetadataAnalysis: string;
    pageCountCheck: string;
    coverCandidate: string;
    confirmedCover: string;
    bibliographicCandidate: string;
    autoDraftCandidates: AutoDraftCandidate[];
    autoAnalysisNotes: string;
    candidateReviewNote: string;
    candidateChangeLog: string[];
    urlAnalysis: UrlAnalysisResult | null;
    isbn: string;
    issn: string;
    kdc: string;
    language: string;
    marcFields: string;
    authorityCandidate: string;
    aiKdc: string;
    aiAuthority: string;
    aiMarc: string;
    confirmedKdc: string;
    confirmedAuthority: string;
    confirmedMarc: string;
    aiSubjectKeywords: string;
    confirmedSubjectKeywords: string;
    classification: string;
    relatedCollections: string;
    summaryAi: string;
    summaryConfirmed: string;
    bodyIndexAi: string;
    bodyIndexConfirmed: string;
    evidenceNote: string;
    fulltextPossession: string;
    fulltextReadable: string;
    accessLevel: string;
    permissionRequired: string;
    rightsNote: string;
    reviewStatus: string;
    requestReview: boolean;
    reviewNote: string;
}

@Component({
    selector: 'wiz-page-admin-materials-new',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.materials.new/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.registration-page {
  width: min(1320px, 100% - 48px);
  min-height: 100vh;
  margin: 0 auto;
  padding: 20px 0 36px;
  background: linear-gradient(180deg, rgba(244, 246, 248, 0.92), rgba(250, 250, 250, 0.96) 280px), var(--design-bg);
  color: var(--design-text);
  font-family: SUIT, Arial, sans-serif;
}

p,
h1,
h2,
h3,
summary {
  margin: 0;
}

.registration-header,
.operator-strip,
.stage-nav,
.save-summary,
.form-section,
.denied-panel,
.notice {
  border: 1px solid var(--design-border);
  border-radius: 8px;
  background: var(--admin-panel-bg);
  box-shadow: var(--design-shadow);
}

.registration-header,
.operator-strip,
.section-heading,
.save-summary,
.save-state,
.stage-nav-title,
.form-actions {
  display: flex;
  justify-content: space-between;
  gap: 14px;
}

.registration-header {
  align-items: flex-start;
  padding: 18px 20px;
}

.registration-header p,
.registration-header span,
.operator-strip,
.stage-nav-title span,
.stage-nav small,
.section-heading p,
.section-heading small,
.field-label,
.help-text,
.notice,
.form-actions a,
.missing-list span,
.analysis-status-grid span,
.analysis-status-grid small,
.file-drop small {
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 800;
}

.registration-header h1 {
  margin-top: 6px;
  font-size: 24px;
  font-weight: 850;
  line-height: 1.2;
  letter-spacing: 0;
}

.registration-header span {
  display: block;
  margin-top: 7px;
  line-height: 1.45;
}

.registration-header nav {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.registration-header a,
.form-actions a,
.form-actions button,
.denied-panel a {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 0 12px;
  background: #ffffff;
  color: var(--design-accent);
  font-size: 13px;
  font-weight: 850;
  line-height: 1.2;
  text-decoration: none;
  white-space: nowrap;
}

.registration-header a:hover,
.registration-header a:focus-visible,
.form-actions a:hover,
.form-actions a:focus-visible,
.denied-panel a:hover,
.denied-panel a:focus-visible {
  border-color: var(--design-border-strong);
  background: var(--admin-button-secondary-hover);
  box-shadow: var(--design-focus-ring);
}

.operator-strip {
  align-items: center;
  margin: 12px 0;
  padding: 12px 16px;
}

.operator-strip div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.operator-strip strong {
  font-size: 14px;
  font-weight: 850;
}

.registration-workbench {
  display: grid;
  grid-template-columns: 244px minmax(0, 1fr);
  gap: 14px;
  align-items: start;
}

.stage-nav {
  position: sticky;
  top: 16px;
  display: grid;
  gap: 8px;
  padding: 14px;
  background: #fbfbfa;
}

.stage-nav-title {
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--design-border-soft);
}

.stage-nav-title strong {
  font-size: 13px;
  font-weight: 850;
}

.stage-nav a {
  min-width: 0;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 9px;
  color: var(--design-text);
  text-decoration: none;
}

.stage-nav a:hover,
.stage-nav a:focus-visible {
  border-color: var(--design-border-soft);
  background: #ffffff;
  box-shadow: var(--design-focus-ring);
}

.stage-nav a.active {
  border-color: var(--design-accent);
  background: #ffffff;
  box-shadow: inset 3px 0 0 var(--design-accent);
}

.stage-nav a.active em {
  background: var(--design-accent);
  color: var(--design-on-accent);
}

.notice.warning {
  border-color: #d5b66a;
  background: #fff9e8;
  color: #6f520d;
}

.stage-nav em {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #eceff3;
  color: var(--design-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 850;
}

.stage-nav strong,
.stage-nav small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stage-nav strong {
  font-size: 13px;
  font-weight: 850;
}

.stage-nav small {
  margin-top: 3px;
  font-weight: 750;
}

.form-column,
.registration-form {
  min-width: 0;
  display: grid;
  gap: 12px;
}

.save-summary {
  position: sticky;
  top: 16px;
  z-index: 2;
  align-items: center;
  padding: 14px 16px;
  background: #ffffff;
}

.save-state {
  align-items: center;
  justify-content: flex-start;
}

.save-state strong {
  display: block;
  font-size: 15px;
  font-weight: 850;
}

.save-state p {
  margin-top: 4px;
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 750;
}

.progress-block {
  width: min(420px, 46%);
  min-width: 280px;
}

.progress-track {
  height: 9px;
  overflow: hidden;
  border-radius: 999px;
  background: #e8eaed;
}

.progress-track i {
  height: 100%;
  display: block;
  border-radius: inherit;
  background: linear-gradient(90deg, #59626f, #3f7f72);
}

.missing-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 8px;
}

.missing-list span {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  border: 1px solid rgba(154, 42, 42, 0.18);
  border-radius: 999px;
  padding: 0 8px;
  background: var(--admin-badge-danger-bg);
  color: var(--admin-badge-danger-text);
  font-size: 12px;
}

.missing-list.complete span {
  border-color: rgba(8, 116, 67, 0.18);
  background: var(--admin-badge-public-bg);
  color: var(--admin-badge-public-text);
}

.form-section {
  scroll-margin-top: 96px;
  padding: 16px;
}

.section-heading {
  align-items: flex-start;
  margin-bottom: 12px;
}

.section-heading h2 {
  margin-top: 5px;
  font-size: 18px;
  font-weight: 850;
  line-height: 1.25;
  letter-spacing: 0;
}

.section-heading small {
  display: block;
  margin-top: 6px;
  line-height: 1.45;
}

.section-help {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  margin-bottom: 12px;
  border: 1px solid #d8dde3;
  border-radius: 8px;
  padding: 10px 12px;
  background: #f5f7f9;
}

.section-help strong {
  color: #334155;
  font-size: 13px;
  font-weight: 850;
}

.section-help p {
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 750;
  line-height: 1.45;
}

.status-badge,
.required-badge,
.optional-badge {
  min-height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--design-border-soft);
  border-radius: 999px;
  padding: 0 9px;
  background: #ffffff;
  color: var(--design-text-secondary);
  font-size: 12px;
  font-style: normal;
  font-weight: 850;
  line-height: 1.1;
  white-space: nowrap;
}

.required-badge,
.status-badge.is-required,
.status-badge.is-error {
  border-color: rgba(154, 42, 42, 0.18);
  background: var(--admin-badge-danger-bg);
  color: var(--admin-badge-danger-text);
}

.optional-badge {
  background: #f4f4f5;
}

.status-badge.is-done,
.status-badge.is-review {
  border-color: rgba(8, 116, 67, 0.18);
  background: var(--admin-badge-public-bg);
  color: var(--admin-badge-public-text);
}

.status-badge.is-waiting,
.status-badge.is-saving {
  border-color: rgba(151, 101, 29, 0.22);
  background: var(--admin-badge-hold-bg);
  color: var(--admin-badge-hold-text);
}

.status-badge.is-policy {
  border-color: rgba(50, 83, 116, 0.18);
  background: #eef4f8;
  color: #2f5f7c;
}

.status-badge.is-draft {
  background: #f4f4f5;
}

.source-grid {
  display: grid;
  grid-template-columns: minmax(260px, 0.7fr) minmax(0, 1.3fr);
  gap: 12px;
}

.analysis-command-row,
.cover-preview-row,
.url-analysis-panel,
.candidate-panel {
  margin-top: 12px;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  background: #fbfbfa;
}

.analysis-command-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
}

.analysis-command-row button,
.candidate-panel-actions button,
.candidate-list button,
.candidate-static {
  min-height: 34px;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 0 10px;
  background: #ffffff;
  color: var(--design-accent);
  font-size: 12px;
  font-weight: 850;
  cursor: pointer;
  white-space: nowrap;
}

.candidate-static {
  display: inline-flex;
  align-items: center;
  color: var(--design-text-secondary);
  cursor: default;
}

.analysis-command-row button:hover,
.analysis-command-row button:focus-visible,
.candidate-panel-actions button:hover,
.candidate-panel-actions button:focus-visible,
.candidate-list button:hover,
.candidate-list button:focus-visible {
  border-color: var(--design-border-strong);
  box-shadow: var(--design-focus-ring);
}

.analysis-command-row button:disabled,
.candidate-panel-actions button:disabled {
  cursor: not-allowed;
  opacity: 0.64;
}

.analysis-command-row span {
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 800;
  line-height: 1.4;
}

.source-fields,
label,
.dual-grid > div {
  min-width: 0;
  display: grid;
  gap: 6px;
}

.source-fields {
  gap: 10px;
}

.file-drop {
  align-content: start;
  border: 1px dashed #b8c1cc;
  border-radius: 8px;
  padding: 14px;
  background: #f7f8fa;
}

.file-drop input {
  padding: 8px 10px;
  background: #ffffff;
}

.file-drop strong {
  display: block;
  margin-top: 4px;
  color: var(--design-text);
  font-size: 15px;
  font-weight: 850;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.file-drop small,
.help-text {
  line-height: 1.45;
}

.field-grid,
.dual-grid,
.analysis-status-grid,
.tag-review-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.compact-grid {
  margin-top: 12px;
}

.dual-grid,
.tag-review-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.analysis-status-grid {
  margin-bottom: 12px;
}

.analysis-notice {
  margin-bottom: 12px;
}

.analysis-status-grid article {
  min-width: 0;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 12px;
  background: #fbfbfa;
}

.analysis-status-grid strong {
  display: block;
  margin-top: 6px;
  color: var(--design-text);
  font-size: 14px;
  font-weight: 850;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.analysis-status-grid small {
  display: block;
  margin-top: 6px;
  line-height: 1.4;
}

.cover-preview-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
}

.cover-preview-row img {
  width: 96px;
  max-height: 136px;
  object-fit: contain;
  border: 1px solid var(--design-border-soft);
  border-radius: 6px;
  background: #ffffff;
}

.cover-preview-row strong,
.url-analysis-head strong,
.candidate-panel-head strong,
.url-candidate-grid strong {
  display: block;
  color: var(--design-text);
  font-size: 14px;
  font-weight: 850;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.cover-preview-row span,
.url-analysis-panel p,
.candidate-panel-head span,
.candidate-panel-head em,
.candidate-list span,
.candidate-list small,
.url-candidate-grid span,
.url-candidate-grid small {
  color: var(--design-text-secondary);
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  line-height: 1.4;
}

.url-analysis-panel,
.candidate-panel {
  padding: 12px;
}

.url-analysis-head,
.candidate-panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.url-analysis-panel p {
  margin-top: 8px;
}

.url-candidate-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-top: 10px;
}

.url-candidate-grid article {
  min-width: 0;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 10px;
  background: #ffffff;
}

.url-candidate-grid small {
  display: block;
  margin-top: 6px;
  overflow-wrap: anywhere;
}

.candidate-panel-head {
  align-items: center;
  margin-bottom: 10px;
}

.candidate-panel-actions,
.candidate-review-summary,
.candidate-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.candidate-panel-actions {
  justify-content: flex-end;
}

.candidate-panel-head em,
.candidate-review-summary span,
.candidate-kind {
  min-height: 26px;
  display: inline-flex;
  align-items: center;
  border: 1px solid rgba(151, 101, 29, 0.22);
  border-radius: 999px;
  padding: 0 9px;
  background: var(--admin-badge-hold-bg);
  color: var(--admin-badge-hold-text);
}

.candidate-kind {
  background: #fff7ed;
}

.candidate-review-summary {
  margin-bottom: 10px;
}

.candidate-review-summary span {
  border-color: var(--design-border-soft);
  background: #ffffff;
  color: var(--design-text-secondary);
}

.candidate-list {
  display: grid;
  gap: 8px;
}

.candidate-list article {
  min-width: 0;
  display: grid;
  gap: 10px;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 10px;
  background: #ffffff;
}

.candidate-list article.is-rejected {
  border-color: rgba(154, 42, 42, 0.18);
  background: #fff8f8;
}

.candidate-card-head,
.candidate-value-grid,
.candidate-note {
  min-width: 0;
}

.candidate-card-head > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 5px;
}

.candidate-value-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.candidate-value-grid label,
.candidate-note,
.candidate-history {
  min-width: 0;
  display: grid;
  gap: 6px;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 10px;
  background: #fbfbfa;
}

.candidate-readonly output,
.candidate-history p {
  margin: 0;
  color: var(--design-body-text);
  font-size: 13px;
  font-weight: 750;
  line-height: 1.45;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.candidate-list strong {
  display: block;
  margin-top: 4px;
  color: var(--design-text);
  font-size: 13px;
  font-weight: 850;
  line-height: 1.4;
  overflow-wrap: anywhere;
  white-space: pre-line;
}

.candidate-list small {
  display: block;
  margin-top: 5px;
}

.candidate-actions {
  justify-content: flex-end;
}

.candidate-actions .secondary {
  color: var(--design-text-secondary);
}

.candidate-actions .danger {
  border-color: rgba(154, 42, 42, 0.18);
  background: var(--admin-badge-danger-bg);
  color: var(--admin-badge-danger-text);
}

.status-badge.is-unchecked {
  border-color: rgba(151, 101, 29, 0.22);
  background: var(--admin-badge-hold-bg);
  color: var(--admin-badge-hold-text);
}

.status-badge.is-applied {
  border-color: rgba(8, 116, 67, 0.18);
  background: var(--admin-badge-public-bg);
  color: var(--admin-badge-public-text);
}

.status-badge.is-edited {
  border-color: rgba(50, 83, 116, 0.18);
  background: #eef4f8;
  color: #2f5f7c;
}

.status-badge.is-rejected {
  border-color: rgba(154, 42, 42, 0.18);
  background: var(--admin-badge-danger-bg);
  color: var(--admin-badge-danger-text);
}

.dual-grid {
  margin-top: 10px;
}

.dual-grid > div {
  gap: 10px;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 12px;
  background: #f7f8fa;
}

.dual-grid h3 {
  font-size: 14px;
  font-weight: 850;
}

input,
select,
textarea {
  width: 100%;
  min-height: 38px;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 0 10px;
  background: #ffffff;
  color: var(--design-body-text);
  font-size: 13px;
  font-weight: 750;
  outline: none;
}

textarea {
  min-height: 88px;
  padding: 10px;
  line-height: 1.45;
  resize: vertical;
}

input:focus,
select:focus,
textarea:focus {
  border-color: var(--design-focus-ring-color);
  box-shadow: var(--design-focus-ring);
}

input[readonly],
input[disabled] {
  background: var(--design-bg-muted);
  color: var(--design-text-secondary);
}

.field-label {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.wide,
.half {
  grid-column: span 2;
}

.check-field {
  min-height: 38px;
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: end;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 0 10px;
  background: #ffffff;
}

.check-field input {
  width: 16px;
  min-height: 16px;
}

.check-field span {
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 800;
}

.advanced-fields {
  margin-top: 12px;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  background: #fbfbfa;
}

.advanced-fields summary {
  cursor: pointer;
  padding: 12px;
  color: var(--design-text);
  font-size: 13px;
  font-weight: 850;
}

.advanced-fields .dual-grid {
  margin: 0;
  padding: 0 12px 12px;
}

.form-actions {
  justify-content: flex-end;
}

.form-actions button {
  border-color: var(--admin-button-primary-bg);
  background: var(--admin-button-primary-bg);
  color: var(--design-on-accent);
  cursor: pointer;
}

.form-actions button:hover,
.form-actions button:focus-visible {
  border-color: var(--admin-button-primary-hover);
  background: var(--admin-button-primary-hover);
  box-shadow: var(--design-focus-ring);
}

.form-actions button:disabled {
  cursor: not-allowed;
  opacity: 0.64;
}

.notice {
  margin: 0 0 14px;
  padding: 10px 12px;
}

.notice.success {
  border-color: rgba(8, 116, 67, 0.18);
  background: var(--admin-badge-public-bg);
  color: var(--admin-badge-public-text);
}

.notice.error {
  border-color: rgba(154, 42, 42, 0.18);
  background: var(--admin-badge-danger-bg);
  color: var(--admin-badge-danger-text);
}

.notice span {
  margin-left: 8px;
}

.denied-page {
  display: grid;
  place-items: center;
}

.denied-panel {
  width: min(420px, 100%);
  padding: 24px;
  text-align: center;
}

.denied-panel h1 {
  margin: 8px 0 18px;
  font-size: 22px;
  font-weight: 850;
}

@media (max-width: 1120px) {
  .registration-workbench {
    grid-template-columns: 1fr;
  }
  .stage-nav,
  .save-summary {
    position: static;
  }
  .stage-nav {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .stage-nav-title {
    grid-column: 1/-1;
  }
}
/* Review 161: three-step registration and real-file status */
.source-path-grid,
.final-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.source-path-card,
.final-summary-grid article,
.empty-candidate-state,
.previous-analysis,
.advanced-options,
.save-policy-note,
.transfer-status {
  min-width: 0;
  border: 1px solid #D8D8D8;
  border-radius: 8px;
  padding: 14px;
  background: #F5F5F5;
}

.source-path-card {
  display: grid;
  align-content: start;
  gap: 10px;
}

.source-path-card > strong,
.final-summary-grid strong,
.empty-candidate-state strong,
.save-policy-note strong {
  color: #2B2B2B;
  line-height: 1.35;
}

.source-path-card p,
.final-summary-grid small,
.empty-candidate-state p,
.previous-analysis p,
.advanced-options p,
.save-policy-note p,
.transfer-status p,
.plain-status {
  color: #606060;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.source-path-card .file-drop {
  height: 100%;
  background: #FFFFFF;
}

.source-path-card button,
.url-analysis-panel > button,
.section-footer-actions button {
  min-height: 40px;
  border: 1px solid #2B2B2B;
  border-radius: 8px;
  padding: 0 14px;
  background: #2B2B2B;
  color: #FFFFFF;
  font-weight: 600;
  cursor: pointer;
}

.secondary-button,
.source-path-card button.secondary-button,
.url-analysis-panel > button.secondary-button,
.section-footer-actions button.secondary-button,
.form-actions button.secondary-button {
  border-color: #BDBDBD;
  background: #FFFFFF;
  color: #2B2B2B;
}

.transfer-status {
  margin-top: 12px;
  background: #FFFFFF;
}

.transfer-status .progress-track {
  width: 100%;
  margin: 8px 0;
}

.core-fields {
  margin-top: 14px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.core-fields .wide {
  grid-column: span 2;
}

.candidate-value-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.empty-candidate-state,
.previous-analysis,
.advanced-options,
.save-policy-note {
  margin-top: 12px;
}

.previous-analysis summary,
.advanced-options summary {
  cursor: pointer;
  color: #2B2B2B;
  font-weight: 700;
}

.previous-analysis ul {
  margin: 10px 0 0;
  padding-left: 20px;
}

.previous-analysis li {
  margin-top: 6px;
  color: #606060;
  overflow-wrap: anywhere;
}

.advanced-options[open] > p,
.previous-analysis[open] > p {
  margin-top: 8px;
}

.final-summary-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.final-summary-grid article {
  display: grid;
  gap: 6px;
  background: #FFFFFF;
}

.final-summary-grid article > span {
  color: #606060;
  font-weight: 600;
}

.section-footer-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.form-actions button {
  min-height: 42px;
  border-radius: 8px;
  padding: 0 16px;
}

.denied-card {
  width: min(440px, 100%);
  border: 1px solid #D8D8D8;
  border-radius: 8px;
  padding: 28px;
  background: #FFFFFF;
  text-align: center;
}

.denied-card h1 {
  margin: 8px 0;
}

.denied-card div {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}

.denied-card a {
  border: 1px solid #2B2B2B;
  border-radius: 8px;
  padding: 8px 12px;
  color: #2B2B2B;
  text-decoration: none;
}

@media (max-width: 980px) {
  .source-path-grid,
  .core-fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 720px) {
  .source-path-grid,
  .core-fields,
  .final-summary-grid,
  .candidate-value-grid {
    grid-template-columns: 1fr;
  }
  .core-fields .wide {
    grid-column: span 1;
  }
  .section-footer-actions,
  .form-actions {
    align-items: stretch;
  }
  .section-footer-actions button,
  .form-actions button {
    width: 100%;
  }
}
@media (max-width: 980px) {
  .source-grid,
  .field-grid,
  .analysis-status-grid,
  .url-candidate-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .save-summary {
    align-items: stretch;
    flex-direction: column;
  }
  .progress-block {
    width: 100%;
    min-width: 0;
  }
  .missing-list {
    justify-content: flex-start;
  }
}
@media (max-width: 720px) {
  .registration-page {
    width: min(100% - 28px, 1320px);
    padding-top: 14px;
  }
  .registration-header,
  .operator-strip,
  .section-heading,
  .analysis-command-row,
  .candidate-list article,
  .url-analysis-head,
  .form-actions {
    align-items: flex-start;
    flex-direction: column;
  }
  .stage-nav,
  .source-grid,
  .field-grid,
  .dual-grid,
  .candidate-value-grid,
  .analysis-status-grid,
  .url-candidate-grid,
  .tag-review-grid {
    grid-template-columns: 1fr;
  }
  .wide,
  .half {
    grid-column: span 1;
  }
  .section-help {
    grid-template-columns: 1fr;
  }
}
/* Review 157 common UI */
:host {
  background: #FFFFFF;
  color: #333333;
  font-size: 16px;
  line-height: 1.6;
}

:host h1,
:host h2,
:host h3,
:host strong {
  font-weight: 700;
}

:host p,
:host span,
:host label,
:host input,
:host select,
:host textarea,
:host button,
:host a,
:host th,
:host td,
:host small,
:host em {
  font-size: max(15px, 1em);
}

:host p,
:host span,
:host td,
:host small,
:host em {
  font-weight: 400;
}

:host label,
:host th,
:host button {
  font-weight: 600;
}

:host input,
:host select,
:host textarea {
  border-color: #D8D8D8;
  background: #FFFFFF;
  color: #333333;
}

:host input:focus,
:host select:focus,
:host textarea:focus {
  border-color: #2B2B2B;
  box-shadow: 0 0 0 3px rgba(43, 43, 43, 0.16);
  outline: none;
}

:host button:disabled,
:host input:disabled,
:host select:disabled,
:host textarea:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

:host .table-scroll {
  max-width: 100%;
  overflow-x: auto;
  overscroll-behavior-inline: contain;
}

:host table th,
:host table td {
  word-break: normal;
  overflow-wrap: break-word;
}

:host table th:first-child,
:host table td:first-child,
:host table th:last-child,
:host table td:last-child {
  white-space: nowrap;
}

:host .status-badge {
  font-size: 13px;
  font-weight: 600;
  word-break: keep-all;
  white-space: normal;
}

:host .notice,
:host .empty-cell,
:host .denied-panel {
  border-color: #D8D8D8;
  background: #F5F5F5;
}

:host .field-error {
  display: block;
  margin-top: 6px;
  color: #9A2A2A;
  font-size: 14px;
  font-weight: 600;
}

.registration-page {
  background: #FFFFFF;
  background-image: none;
}

.registration-header,
.access-summary,
.stage-nav,
.form-section,
.form-actions,
.analysis-panel,
.candidate-panel {
  background: #FFFFFF;
  background-image: none;
  box-shadow: 0 1px 2px rgba(30, 30, 30, 0.06);
}

.access-summary,
.section-help,
.analysis-status-grid,
.advanced-fields {
  background: #F5F5F5;
}

.stage-nav a.active,
.form-actions button {
  border-color: #2B2B2B;
  background: #2B2B2B;
  background-image: none;
  color: #FFFFFF;
}

.stage-nav a:not(.active),
.form-actions a,
.analysis-command-row button,
.candidate-panel-actions button,
.candidate-list button {
  border-color: #BDBDBD;
  background: #FFFFFF;
  background-image: none;
  color: #2B2B2B;
}

.progress-track i {
  background: #2B2B2B;
  background-image: none;
}

.registration-page p,
.registration-page span,
.registration-page a,
.registration-page label,
.registration-page input,
.registration-page select,
.registration-page textarea,
.registration-page td,
.registration-page small,
.registration-page em {
  font-size: 15px;
  font-weight: 400;
}

.registration-page h1,
.registration-page h2,
.registration-page h3,
.registration-page strong {
  font-weight: 700;
}

.registration-page button,
.registration-page label,
.registration-page th,
.registration-page .field-label {
  font-size: 15px;
  font-weight: 600;
}

.registration-page .status-badge {
  font-size: 13px;
  font-weight: 600;
}`],
})
export class PageAdminMaterialsNewComponent implements OnInit {
    public accessDenied: boolean = false;
    public saving: boolean = false;
    public saveAttempted: boolean = false;
    public message: string = "";
    public errorMessage: string = "";
    public routeNotice: string = "";
    public savedMaterialId: string = "";
    public activeSectionId: string = "source-input";
    public analyzingPdf: boolean = false;
    public analyzingUrl: boolean = false;
    public uploading: boolean = false;
    public uploadPercent: number | null = null;
    public uploadErrorMessage: string = "";
    public analysisErrorMessage: string = "";
    public coverPreviewDataUrl: string = "";
    private pdfjs: any = null;
    private urlAnalysisTimer: any = null;
    private lastAnalyzedUrl: string = "";
    private cleanFormSnapshot: string = "";
    private pendingFile: File | null = null;
    private pdfAnalysisRevision: number = 0;
    private urlAnalysisRevision: number = 0;
    private lastPdfSourceKey: string = "";
    private lastUrlSourceKey: string = "";

    public materialTypes: string[] = [
        "간행도서",
        "학술논문",
        "사료집",
        "외교문서",
        "교육자료",
        "보고서",
        "멀티미디어",
        "기타",
    ];
    public accessLevels: string[] = ["공개", "내부열람", "공개보류", "비공개"];
    public reviewStatuses: string[] = ["등록 초안", "검수 대기", "보완 요청", "검수 완료", "반려"];
    public storageStatuses: string[] = ["원문 등록 대기", "원문 링크 등록", "PDF 확보 완료"];
    public textExtractionStatuses: string[] = ["본문색인 대기", "텍스트추출 필요", "OCR 필요", "본문색인 후보 등록"];
    public fulltextPossessionOptions: string[] = ["확인 필요", "원문 보유", "원문 링크만 보유", "원문 없음"];
    public fulltextReadableOptions: string[] = ["확인 필요", "열람 가능", "내부 열람 가능", "열람 불가"];
    public permissionRequiredOptions: string[] = ["확인 필요", "권한 필요", "권한 불필요"];
    public candidateReviewStatuses: string[] = ["미확인", "적용", "수정됨", "반려"];
    public sections: any[] = [
        { id: "source-input", step: "1", title: "원문 넣기", note: "PDF·URL·정보만 등록" },
        { id: "information-confirm", step: "2", title: "자료 정보 확인", note: "후보 비교·담당자 수정" },
        { id: "save-request", step: "3", title: "저장·확인 요청", note: "파일·공개 범위·남은 확인" },
    ];

    public form: MaterialRegistrationForm = this.emptyForm();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.canRegisterMaterials()) {
            this.accessDenied = true;
        }
        this.restoreSectionFromUrl(true);
        this.markFormClean();
        await this.service.render();
        this.scrollToSection(this.activeSectionId, false);
    }

    public emptyForm(): MaterialRegistrationForm {
        return {
            submissionId: this.newSubmissionId(),
            saveIntent: "review",
            materialIdMode: "auto",
            materialId: "",
            autoGenerationBasis: "NAH-MAN-{YYYYMMDD}-{HHMMSS}-{microseconds}",
            title: "",
            materialType: "",
            contributor: "",
            publicationInfo: "",
            source: "",
            publisher: "동북아역사재단",
            publishedYear: "",
            seriesTitle: "",
            externalIdentifier: "",
            originalUrl: "",
            externalViewUrl: "",
            sourceLink: "",
            fileNote: "",
            storageStatus: "원문 등록 대기",
            textExtractionStatus: "본문색인 대기",
            fileMetadata: null,
            fileNameAnalysis: "",
            pdfMetadataAnalysis: "",
            pageCountCheck: "",
            coverCandidate: "",
            confirmedCover: "",
            bibliographicCandidate: "",
            autoDraftCandidates: [],
            autoAnalysisNotes: "",
            candidateReviewNote: "",
            candidateChangeLog: [],
            urlAnalysis: null,
            isbn: "",
            issn: "",
            kdc: "",
            language: "ko",
            marcFields: "",
            authorityCandidate: "",
            aiKdc: "",
            aiAuthority: "",
            aiMarc: "",
            confirmedKdc: "",
            confirmedAuthority: "",
            confirmedMarc: "",
            aiSubjectKeywords: "",
            confirmedSubjectKeywords: "",
            classification: "",
            relatedCollections: "",
            summaryAi: "",
            summaryConfirmed: "",
            bodyIndexAi: "",
            bodyIndexConfirmed: "",
            evidenceNote: "",
            fulltextPossession: "확인 필요",
            fulltextReadable: "확인 필요",
            accessLevel: "내부열람",
            permissionRequired: "권한 필요",
            rightsNote: "",
            reviewStatus: "검수 대기",
            requestReview: true,
            reviewNote: "",
        };
    }

    public responseMessage(response: any, fallback: string): string {
        let data = response?.data;
        if (typeof data === "string") return data;
        if (data?.message) return data.message;
        return fallback;
    }

    private newSubmissionId(): string {
        let random = Math.random().toString(36).slice(2, 12);
        return `registration-${Date.now()}-${random}`;
    }

    public trackSection(index: number, section: any): string {
        return section.id;
    }

    public currentStepNumber(): number {
        let index = this.sections.findIndex((section) => section.id === this.activeSectionId);
        return index >= 0 ? index + 1 : 1;
    }

    public registrationSectionUrl(sectionId: string): string {
        return `${window.location.pathname}${window.location.search}#${encodeURIComponent(sectionId)}`;
    }

    public async goToSection(sectionId: string, event?: MouseEvent) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.sections.some((section) => section.id === sectionId)) return;
        this.activeSectionId = sectionId;
        this.routeNotice = "";
        let target = this.registrationSectionUrl(sectionId);
        if (`${window.location.pathname}${window.location.search}${window.location.hash}` !== target) {
            window.history.pushState({ registrationSection: sectionId }, "", target);
        }
        await this.service.render();
        this.scrollToSection(sectionId, true);
    }

    private restoreSectionFromUrl(replaceInvalid: boolean = false) {
        let requested = this.text(decodeURIComponent((window.location.hash || "").replace(/^#/, "")));
        if (!requested) requested = "source-input";
        const legacySections: any = {
            "auto-analysis": "information-confirm",
            "bibliographic-confirm": "information-confirm",
            "access-status": "save-request",
            "tag-review": "save-request",
        };
        if (legacySections[requested]) {
            requested = legacySections[requested];
            this.routeNotice = "기존 등록 주소를 현재 3단계 흐름으로 연결했습니다.";
            replaceInvalid = true;
        }
        if (!this.sections.some((section) => section.id === requested)) {
            this.activeSectionId = "source-input";
            this.routeNotice = `지원하지 않는 등록 단계(${requested}) 대신 원문 입력 단계를 표시합니다.`;
            if (replaceInvalid) window.history.replaceState({ registrationSection: this.activeSectionId }, "", this.registrationSectionUrl(this.activeSectionId));
            return;
        }
        this.activeSectionId = requested;
        if (replaceInvalid && !window.location.hash) {
            window.history.replaceState({ registrationSection: requested }, "", this.registrationSectionUrl(requested));
        }
    }

    private scrollToSection(sectionId: string, smooth: boolean) {
        setTimeout(() => document.getElementById(sectionId)?.scrollIntoView({ behavior: smooth ? "smooth" : "auto", block: "start" }), 0);
    }

    private formSnapshot(): string {
        return JSON.stringify(this.form || {});
    }

    private markFormClean() {
        this.cleanFormSnapshot = this.formSnapshot();
    }

    public hasUnsavedChanges(): boolean {
        return !this.saving && !!this.cleanFormSnapshot && this.formSnapshot() !== this.cleanFormSnapshot;
    }

    @HostListener('window:popstate')
    public async handlePopState() {
        this.restoreSectionFromUrl(true);
        await this.service.render();
        this.scrollToSection(this.activeSectionId, false);
    }

    @HostListener('window:beforeunload', ['$event'])
    public handleBeforeUnload(event: BeforeUnloadEvent) {
        if (!this.hasUnsavedChanges()) return;
        event.preventDefault();
        event.returnValue = "";
    }

    public requiredTotal(): number {
        return 7 + (this.form.materialIdMode === "manual" ? 1 : 0);
    }

    public requiredCompleted(): number {
        return Math.max(0, this.requiredTotal() - this.requiredMissing().length);
    }

    public requiredProgressPercent(): number {
        let total = this.requiredTotal();
        if (!total) return 0;
        return Math.round((this.requiredCompleted() / total) * 100);
    }

    public requiredCompletionText(): string {
        let missing = this.requiredMissing();
        if (missing.length === 0) return "필수 항목이 모두 채워져 저장할 수 있습니다.";
        return `${missing.length}개 필수 항목을 더 확인해야 저장할 수 있습니다.`;
    }

    public saveStateLabel(): string {
        if (this.saving) return "저장 중";
        if (this.message) return "저장 완료";
        if (this.errorMessage) return "확인 필요";
        return "저장 전";
    }

    public saveStateClass(): string {
        if (this.saving) return "is-saving";
        if (this.message) return "is-done";
        if (this.errorMessage) return "is-error";
        return "is-draft";
    }

    public fileStateLabel(): string {
        if (this.uploading) return "전송 중";
        if (this.uploadErrorMessage) return "업로드 실패";
        if (this.pendingFile && this.form.fileMetadata?.name) return "저장 전 · PDF 선택됨";
        if (this.text(this.form.originalUrl) || this.text(this.form.externalViewUrl) || this.text(this.form.sourceLink)) {
            return "링크 입력됨";
        }
        return "원문 입력 대기";
    }

    public fileStateClass(): string {
        if (this.uploading) return "is-saving";
        if (this.uploadErrorMessage) return "is-error";
        if (this.pendingFile && this.form.fileMetadata?.name) return "is-waiting";
        if (this.text(this.form.originalUrl) || this.text(this.form.externalViewUrl) || this.text(this.form.sourceLink)) {
            return "is-waiting";
        }
        return "is-draft";
    }

    public analysisStateLabel(): string {
        if (this.analyzingPdf || this.analyzingUrl) return "분석 중";
        if (this.currentCandidates().length > 0) return "후보 준비";
        if (this.analysisErrorMessage) return "분석 실패";
        return "분석 대기";
    }

    public analysisStateClass(): string {
        if (this.analyzingPdf || this.analyzingUrl) return "is-saving";
        if (this.analysisErrorMessage) return "is-error";
        if (this.currentCandidates().length > 0) return "is-waiting";
        return "is-draft";
    }

    public analysisSummaryText(): string {
        let count = this.currentCandidates().length;
        if (this.analyzingPdf || this.analyzingUrl) return "분석 중에도 제목·저자 등 다른 입력을 계속할 수 있습니다.";
        if (count > 0) return `${count}개 후보가 생성되었습니다. 담당자가 적용·수정·비우기·반려한 값만 저장값으로 사용합니다.`;
        return "PDF 파일을 선택하거나 URL을 입력하면 후보값을 생성합니다.";
    }

    public trackCandidate(index: number, item: AutoDraftCandidate): string {
        return `${item.field}-${item.source}-${item.value}-${index}`;
    }

    public trackUrlItem(index: number, item: any): string {
        return `${item?.url || item?.value || index}`;
    }

    public urlAnalysisResult(): UrlAnalysisResult | null {
        return this.form.urlAnalysis || null;
    }

    public currentUserName(): string {
        return this.service.auth.session?.name || this.service.auth.session?.username || "";
    }

    public materialPermissions(): string[] {
        let value = this.service.auth.session?.materialsPermissions || this.service.auth.session?.materials_permissions || [];
        if (Array.isArray(value)) return value;
        if (typeof value === "string" && value.trim()) {
            try {
                let parsed = JSON.parse(value);
                if (Array.isArray(parsed)) return parsed;
            } catch (e) {
                return value.split(",").map((item) => item.trim()).filter((item) => !!item);
            }
        }
        return [];
    }

    public canRegisterMaterials(): boolean {
        let session = this.service.auth.session || {};
        let permissions = this.materialPermissions();
        return session.status === "active" && (
            session.role === "admin" ||
            session.role === "materials" ||
            permissions.includes("materials_admin") ||
            permissions.includes("materials_register")
        );
    }

    public displayTerm(value: any): string {
        let text = value === null || value === undefined ? "" : `${value}`;
        const exact: any = {
            "내부열람": "내부 사용자만 열람",
            "검수 대기": "자료 확인 필요",
            "검수대기": "자료 확인 필요",
            "검수 완료": "자료 확인 완료",
            "검수완료": "자료 확인 완료",
            "OCR 필요": "이미지 속 글자 인식 필요"
        };
        if (exact[text]) return exact[text];
        return text
            .replace(/서지DB/g, "자료 기본정보")
            .replace(/원문DB/g, "원문 파일")
            .replace(/메타데이터/g, "자료 정보")
            .replace(/본문색인/g, "본문 검색")
            .replace(/청크/g, "본문 구간")
            .replace(/태그/g, "주제어")
            .replace(/검수/g, "자료 확인")
            .replace(/내부열람/g, "내부 사용자만 열람")
            .replace(/OCR/g, "이미지 속 글자 인식");
    }

    public hasFieldError(field: string): boolean {
        if (!this.saveAttempted) return false;
        if (field === "materialId") return this.form.materialIdMode === "manual" && !this.text(this.form.materialId);
        return !this.text((this.form as any)[field]);
    }

    public fieldErrorId(field: string): string {
        return `error-${field}`;
    }

    public requiredMissing(): string[] {
        let missing: string[] = [];
        if (this.form.materialIdMode === "manual" && !this.text(this.form.materialId)) missing.push("자료ID");
        if (!this.text(this.form.title)) missing.push("제목");
        if (!this.text(this.form.materialType)) missing.push("자료 유형");
        if (!this.text(this.form.contributor)) missing.push("저자/기관");
        if (!this.text(this.form.publicationInfo)) missing.push("발행정보");
        if (!this.text(this.form.source)) missing.push("등록 출처");
        if (!this.text(this.form.accessLevel)) missing.push("공개 등급");
        if (!this.text(this.form.reviewStatus)) missing.push("검수 상태");
        return missing;
    }

    public text(value: any): string {
        if (value === null || value === undefined) return "";
        return `${value}`.trim();
    }

    public fileSizeLabel(): string {
        let size = Number(this.form.fileMetadata?.size || 0);
        if (!size) return "";
        if (size < 1024) return `${size} B`;
        if (size < 1024 * 1024) return `${Math.round(size / 1024)} KB`;
        return `${(size / 1024 / 1024).toFixed(1)} MB`;
    }

    public candidateValuePreview(value: string): string {
        value = this.text(value);
        if (value.length <= 160) return value;
        return `${value.slice(0, 160)}...`;
    }

    public candidateFieldLabel(field: string): string {
        let labels: any = {
            title: "제목",
            materialType: "자료유형",
            contributor: "저자/편찬기관",
            publicationInfo: "발행정보",
            source: "등록 출처",
            publisher: "발행기관",
            publishedYear: "발행연도",
            originalUrl: "원문 URL",
            externalViewUrl: "외부 열람 URL",
            sourceLink: "원본 링크",
            fulltextPossession: "원문 보유 상태",
            textExtractionStatus: "본문색인 상태",
            storageStatus: "원문DB 상태",
            isbn: "ISBN",
            issn: "ISSN",
            aiSubjectKeywords: "담당자 확정 태그",
            coverCandidate: "표지 확정값",
        };
        return labels[field] || field;
    }

    public candidateCanApply(candidate: AutoDraftCandidate): boolean {
        if (!candidate || candidate.stale) return false;
        let field = this.confirmedFieldForCandidate(candidate.field);
        return Object.prototype.hasOwnProperty.call(this.form, field);
    }

    public candidateReviewValue(candidate: AutoDraftCandidate): string {
        if (candidate.reviewValue !== undefined && candidate.reviewValue !== null) return this.text(candidate.reviewValue);
        return this.text(candidate.value);
    }

    public candidateStatusLabel(candidate?: AutoDraftCandidate): string {
        return this.normalizeCandidateStatus(candidate?.status);
    }

    public candidateStatusClass(candidate: AutoDraftCandidate): string {
        let status = this.candidateStatusLabel(candidate);
        if (status === "적용") return "is-applied";
        if (status === "수정됨") return "is-edited";
        if (status === "반려") return "is-rejected";
        return "is-unchecked";
    }

    public candidateSourceType(candidate?: AutoDraftCandidate): string {
        let source = this.text(candidate?.source).toLowerCase();
        let label = this.text(candidate?.label).toLowerCase();
        if (source.includes("pdf 메타데이터") || label.includes("pdf 메타데이터")) return "PDF 메타데이터";
        if (source.includes("파일명") || source.includes("업로드 파일")) return "파일명";
        if (source.includes("url") || source.includes("html") || source.includes("canonical")) return "외부 URL";
        if (source.includes("첫 페이지") || source.includes("본문")) return "본문 첫 페이지";
        if (source.includes("pdf 구조")) return "PDF 구조";
        return "자동 분석";
    }

    public candidateCountByStatus(status: string): number {
        return this.currentCandidates().filter((candidate) => this.candidateStatusLabel(candidate) === status).length;
    }

    public currentCandidates(): AutoDraftCandidate[] {
        return (this.form.autoDraftCandidates || []).filter((candidate) => !candidate.stale);
    }

    public previousCandidates(): AutoDraftCandidate[] {
        return (this.form.autoDraftCandidates || []).filter((candidate) => !!candidate.stale);
    }

    public currentValueForCandidate(candidate: AutoDraftCandidate): string {
        let field = this.confirmedFieldForCandidate(candidate?.field || "");
        return Object.prototype.hasOwnProperty.call(this.form, field) ? this.text((this.form as any)[field]) : "표시 전용";
    }

    public applyAllCandidatesLabel(): string {
        let actionable = this.currentCandidates().filter((candidate) => this.candidateCanApply(candidate) && this.candidateStatusLabel(candidate) !== "반려").length;
        return actionable > 0 ? `전체 후보 적용 ${actionable}개` : "적용 가능한 후보 없음";
    }

    public async applyAllCandidates() {
        let selectedByField: any = {};
        this.currentCandidates().forEach((candidate) => {
            if (!this.candidateCanApply(candidate) || this.candidateStatusLabel(candidate) === "반려") return;
            selectedByField[this.confirmedFieldForCandidate(candidate.field)] = candidate;
        });
        Object.keys(selectedByField).forEach((field) => {
            this.applyCandidateReviewValue(selectedByField[field], "전체 적용");
        });
        await this.service.render();
    }

    public async applyCandidate(candidate: AutoDraftCandidate) {
        this.applyCandidateReviewValue(candidate, "적용");
        await this.service.render();
    }

    public async clearCandidate(candidate: AutoDraftCandidate) {
        if (!this.candidateCanApply(candidate)) return;
        let field = this.confirmedFieldForCandidate(candidate.field);
        (this.form as any)[field] = "";
        candidate.reviewValue = "";
        candidate.status = "수정됨";
        candidate.applied = false;
        candidate.updatedAt = this.nowStamp();
        this.logCandidateChange(candidate, "비우기", "");
        await this.service.render();
    }

    public async rejectCandidate(candidate: AutoDraftCandidate) {
        if (!candidate) return;
        let field = this.confirmedFieldForCandidate(candidate.field);
        let current = this.text((this.form as any)[field]);
        let reviewValue = this.candidateReviewValue(candidate);
        if (this.candidateCanApply(candidate) && current && current === reviewValue) {
            (this.form as any)[field] = "";
        }
        candidate.status = "반려";
        candidate.applied = false;
        candidate.updatedAt = this.nowStamp();
        this.logCandidateChange(candidate, "반려", reviewValue);
        await this.service.render();
    }

    public async onOriginalFileSelected(event: any) {
        let file = event?.target?.files && event.target.files[0];
        this.pdfAnalysisRevision += 1;
        this.retireCandidates("pdf");
        this.uploadErrorMessage = "";
        if (!file) {
            this.analyzingPdf = false;
            this.pendingFile = null;
            this.form.fileMetadata = null;
            this.coverPreviewDataUrl = "";
            await this.service.render();
            return;
        }
        if (!/\.pdf$/i.test(file.name) || !["", "application/pdf", "application/octet-stream", "application/x-pdf"].includes(file.type || "")) {
            this.pendingFile = null;
            this.form.fileMetadata = null;
            this.analysisErrorMessage = "PDF 형식만 등록할 수 있습니다. 파일을 바꾼 뒤 다시 시도해주세요.";
            event.target.value = "";
            await this.service.render();
            return;
        }
        if (Number(file.size || 0) > 250 * 1024 * 1024) {
            this.pendingFile = null;
            this.form.fileMetadata = null;
            this.analysisErrorMessage = "PDF 파일은 1개, 250MB까지 등록할 수 있습니다.";
            event.target.value = "";
            await this.service.render();
            return;
        }
        this.pendingFile = file;
        this.form.fileMetadata = {
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified,
        };
        this.form.storageStatus = "원문 등록 대기";
        this.lastPdfSourceKey = `${file.name}:${file.size}:${file.lastModified}`;
        await this.analyzePdfFile(file, this.pdfAnalysisRevision, this.lastPdfSourceKey);
    }

    public scheduleUrlAnalysis() {
        if (this.urlAnalysisTimer) window.clearTimeout(this.urlAnalysisTimer);
        let url = this.primaryUrlInput();
        if (url !== this.lastUrlSourceKey) {
            this.urlAnalysisRevision += 1;
            this.analyzingUrl = false;
            this.retireCandidates("url");
            this.lastUrlSourceKey = url;
            this.form.urlAnalysis = null;
        }
        if (!this.isLikelyUrl(url) || url === this.lastAnalyzedUrl) return;
        this.urlAnalysisTimer = window.setTimeout(async () => {
            await this.analyzeUrl(false);
        }, 900);
    }

    public async runSourceAnalysis() {
        await this.analyzeUrl(true);
    }

    public async analyzeUrl(showMissingMessage: boolean = true) {
        let url = this.primaryUrlInput();
        if (!url) {
            if (showMissingMessage) this.analysisErrorMessage = "분석할 URL을 입력해주세요. PDF 원문 URL, 외부 열람 URL, 원본 링크 중 하나를 사용할 수 있습니다.";
            await this.service.render();
            return;
        }
        if (!this.isLikelyUrl(url)) {
            if (showMissingMessage) this.analysisErrorMessage = "http 또는 https로 시작하는 URL만 자동 분석할 수 있습니다. 수동 입력은 계속 가능합니다.";
            await this.service.render();
            return;
        }

        this.analysisErrorMessage = "";
        this.analyzingUrl = true;
        let revision = ++this.urlAnalysisRevision;
        this.lastUrlSourceKey = url;
        this.retireCandidates("url");
        await this.service.render();

        try {
            let response: any = await wiz.call("analyze_url", { url });
            if (response.code !== 200) {
                let failure = this.responseMessage(response, "URL 자동 분석에 실패했습니다.");
                this.analysisErrorMessage = `${failure} 수동 정보 입력은 계속 가능합니다.`;
                return;
            }

            let result: UrlAnalysisResult = response.data?.result || {};
            if (revision !== this.urlAnalysisRevision || this.primaryUrlInput() !== url) {
                this.analysisErrorMessage = "이전 URL의 늦은 분석 결과는 현재 입력에 적용하지 않았습니다.";
                return;
            }
            this.form.urlAnalysis = result;
            this.lastAnalyzedUrl = url;
            this.applyUrlAnalysisResult(result, url);
            if (!result.accessible) {
                this.analysisErrorMessage = result.message || "URL에 접근하지 못했습니다. 주소와 권한을 확인한 뒤 수동 입력을 계속할 수 있습니다.";
            }
        } catch (e) {
            this.analysisErrorMessage = `URL 자동 분석 중 오류가 발생했습니다. 수동 입력은 계속 가능합니다. (${this.text(e) || "분석 오류"})`;
        } finally {
            if (revision === this.urlAnalysisRevision) this.analyzingUrl = false;
            await this.service.render();
        }
    }

    public async save(intent: string = "draft") {
        if (this.saving || this.uploading) return;
        this.saveAttempted = true;
        this.message = "";
        this.errorMessage = "";
        this.savedMaterialId = "";
        let missing = this.requiredMissing();
        if (missing.length > 0) {
            this.errorMessage = `필수 입력값을 확인해주세요: ${missing.join(", ")}`;
            await this.service.render();
            return;
        }
        this.form.autoDraftCandidates = this.form.autoDraftCandidates.map((candidate) => ({
            ...candidate,
            status: this.candidateStatusLabel(candidate),
            reviewValue: this.candidateReviewValue(candidate),
        }));
        this.form.bibliographicCandidate = this.buildBibliographicCandidateSummary();
        this.form.saveIntent = intent === "review" ? "review" : "draft";
        this.form.requestReview = this.form.saveIntent === "review";
        this.form.reviewStatus = this.form.requestReview ? "검수 대기" : "등록 초안";

        this.saving = true;
        this.uploading = !!this.pendingFile;
        this.uploadPercent = this.pendingFile ? 0 : null;
        this.uploadErrorMessage = "";
        await this.service.render();
        let response: any;
        try {
            response = await this.uploadRegistration();
        } catch (e) {
            response = { code: 0, data: { message: "전송이 중단되었습니다. 입력값을 보존했습니다. 다시 시도해주세요." } };
        }
        this.saving = false;
        this.uploading = false;
        if (response.code !== 200) {
            this.errorMessage = this.responseMessage(response, "자료 등록 정보를 저장하지 못했습니다.");
            this.uploadErrorMessage = this.pendingFile ? this.errorMessage : "";
            await this.service.render();
            return;
        }

        if (this.pendingFile && (!response.data?.fileStored || !response.data?.fileId)) {
            this.errorMessage = "서버에서 PDF 실파일 저장과 파일ID를 확인하지 못했습니다. 입력값을 보존했으며 다시 시도할 수 있습니다.";
            this.uploadErrorMessage = this.errorMessage;
            await this.service.render();
            return;
        }

        this.savedMaterialId = response.data?.id || "";
        this.message = response.data?.message || "자료 등록 정보가 저장되었습니다.";
        this.markFormClean();
        await this.service.render();
        let detailUrl = this.text(response.data?.detailUrl) || `/admin/materials/detail/${encodeURIComponent(this.savedMaterialId)}?tab=original`;
        window.location.assign(detailUrl);
    }

    private uploadRegistration(): Promise<any> {
        return new Promise((resolve) => {
            let body = new FormData();
            body.append("payload", JSON.stringify(this.form));
            if (this.pendingFile) body.append("file", this.pendingFile, this.pendingFile.name);
            let xhr = new XMLHttpRequest();
            xhr.open("POST", "/wiz/api/page.admin.materials.new/save", true);
            xhr.upload.onprogress = (event: ProgressEvent) => {
                if (!event.lengthComputable) {
                    this.uploadPercent = null;
                } else {
                    this.uploadPercent = Math.min(100, Math.round((event.loaded / event.total) * 100));
                }
                this.service.render();
            };
            xhr.onerror = () => resolve({ code: 0, data: { message: "전송이 중단되었습니다. 다시 시도할 수 있습니다." } });
            xhr.onabort = () => resolve({ code: 0, data: { message: "전송이 중단되었습니다. 다시 시도할 수 있습니다." } });
            xhr.onload = () => {
                let parsed: any = {};
                try { parsed = JSON.parse(xhr.responseText || "{}"); } catch (e) { parsed = { message: xhr.responseText || "저장 요청에 실패했습니다." }; }
                resolve(parsed && typeof parsed.code === "number" ? parsed : { code: xhr.status, data: parsed });
            };
            xhr.send(body);
        });
    }

    private primaryUrlInput(): string {
        return this.text(this.form.originalUrl) || this.text(this.form.externalViewUrl) || this.text(this.form.sourceLink);
    }

    public uploadProgressText(): string {
        if (!this.uploading) return "";
        return this.uploadPercent === null ? "전송 중 · 서버가 전체 크기를 제공하지 않았습니다." : `전송 중 ${this.uploadPercent}%`;
    }

    public urlResourceLabel(result?: UrlAnalysisResult | null): string {
        if (!result) return "분석 대기";
        if (!result.accessible) return "접근 실패";
        if (result.resourceType === "pdf") return "PDF 링크";
        if (result.resourceType === "unsupported") return "지원하지 않는 페이지";
        if (result.resourceType === "html") return "웹페이지";
        return "형식 확인 필요";
    }

    public sourceSummary(): string {
        if (this.pendingFile) return `${this.pendingFile.name} · ${this.fileSizeLabel()} · 저장 전`;
        let url = this.primaryUrlInput();
        if (url) return `${url} · 링크만 등록`;
        return "원문 없이 자료 정보만 등록";
    }

    public unresolvedCandidateCount(): number {
        return this.currentCandidates().filter((candidate) => this.candidateStatusLabel(candidate) === "미확인").length;
    }

    public hasActualUploadPending(): boolean {
        return !!this.pendingFile;
    }

    public hasSourceUrl(): boolean {
        return !!this.primaryUrlInput();
    }

    private isLikelyUrl(value: string): boolean {
        return /^https?:\/\/\S+\.\S+/i.test(this.text(value));
    }

    private async analyzePdfFile(file: File, revision: number, sourceKey: string) {
        this.analysisErrorMessage = "";
        this.analyzingPdf = true;
        this.addCandidate("fileName", "파일명", file.name, "업로드 파일명에서 추출", false);
        this.addCandidate("fileSize", "파일 크기", this.humanFileSize(file.size), "업로드 파일 정보에서 추출", false);
        this.addCandidate("storageStatus", "원문 보유 상태 후보", "원문 등록 대기", "업로드 파일 정보에서 추정");
        this.addCandidate("fulltextPossession", "원문 보유 상태 후보", "원문 보유", "업로드 파일 정보에서 추정");
        this.addCandidate("source", "등록 출처 후보", "PDF 파일 업로드", "업로드 파일 정보에서 추정");

        let filenameTitle = this.titleFromFilename(file.name);
        this.form.fileNameAnalysis = `파일명에서 추정: ${filenameTitle || file.name}`;
        this.addCandidate("title", "자료 제목 후보", filenameTitle, "파일명에서 추정");

        await this.service.render();
        let pdf: any = null;
        try {
            let lib = await this.ensurePdfjs();
            let data = new Uint8Array(await file.arrayBuffer());
            if (revision !== this.pdfAnalysisRevision || this.pendingFile !== file || sourceKey !== this.lastPdfSourceKey) return;
            let loadingTask = lib.getDocument({ data });
            pdf = await loadingTask.promise;
            let pageCount = Number(pdf.numPages || 0);
            let metadata = await pdf.getMetadata().catch(() => null);
            let info = metadata?.info || {};
            let metaTitle = this.normalizePdfMetaValue(info.Title);
            let metaAuthor = this.normalizePdfMetaValue(info.Author);
            let metaSubject = this.normalizePdfMetaValue(info.Subject);
            let metaCreator = this.normalizePdfMetaValue(info.Creator);
            let metaProducer = this.normalizePdfMetaValue(info.Producer);
            let metaYear = this.extractYear(this.normalizePdfMetaValue(info.CreationDate) || this.normalizePdfMetaValue(info.ModDate));
            let sampledText = await this.extractPdfTextSample(pdf, Math.min(pageCount, 3));
            if (revision !== this.pdfAnalysisRevision || this.pendingFile !== file || sourceKey !== this.lastPdfSourceKey) return;
            let ocrRequired = sampledText.length < 40;
            let isbn = this.extractIsbn(`${sampledText} ${metaSubject}`);
            let issn = this.extractIssn(`${sampledText} ${metaSubject}`);
            let titleCandidate = metaTitle || filenameTitle;
            let materialType = this.inferMaterialType(`${titleCandidate} ${sampledText}`);
            let tags = this.inferTags(`${titleCandidate} ${metaSubject} ${sampledText}`);

            this.form.pageCountCheck = pageCount ? `${pageCount}쪽 (PDF 파일에서 추출 · 검수 필요)` : "페이지 수 확인 필요";
            this.form.pdfMetadataAnalysis = this.pdfMetadataSummary(info);
            this.form.coverCandidate = pageCount ? "PDF 1쪽 렌더링 표지 후보 (PDF 파일에서 추출 · 검수 필요)" : "표지 후보 확인 필요";
            this.form.textExtractionStatus = ocrRequired ? "OCR 필요" : "본문색인 후보 등록";
            let coverPreview = pageCount ? await this.renderCoverPreview(pdf) : "";
            if (revision !== this.pdfAnalysisRevision || this.pendingFile !== file || sourceKey !== this.lastPdfSourceKey) return;
            this.coverPreviewDataUrl = coverPreview;

            this.addCandidate("pageCount", "PDF 페이지 수", `${pageCount || "확인 필요"}쪽`, "PDF 구조에서 추출", false);
            this.addCandidate("title", "PDF 제목 메타데이터", metaTitle, "PDF 메타데이터 Title에서 추출");
            this.addCandidate("title", "자료 제목 후보", titleCandidate, metaTitle ? "PDF 메타데이터에서 추출" : "파일명에서 추정");
            this.addCandidate("contributor", "저자/편찬기관 후보", metaAuthor || metaCreator, metaAuthor ? "PDF 메타데이터 Author에서 추출" : "PDF 메타데이터 Creator에서 추출");
            this.addCandidate("publisher", "발행기관 후보", this.publisherFromText(`${metaSubject} ${sampledText}`), "PDF 메타데이터/본문에서 추정");
            this.addCandidate("publishedYear", "발행연도 후보", metaYear || this.extractYear(`${file.name} ${sampledText}`), metaYear ? "PDF 메타데이터 날짜에서 추출" : "파일명/본문에서 추정");
            this.addCandidate("materialType", "자료유형 후보", materialType, "파일명/첫 페이지 텍스트에서 추정");
            this.addCandidate("isbn", "ISBN 후보", isbn, "PDF 첫 페이지 텍스트에서 추출");
            this.addCandidate("issn", "ISSN 후보", issn, "PDF 첫 페이지 텍스트에서 추출");
            this.addCandidate("coverCandidate", "표지 이미지 후보", this.form.coverCandidate, "PDF 첫 페이지에서 추출");
            this.addCandidate("textExtractionStatus", "OCR 필요 여부 후보", ocrRequired ? "OCR 필요" : "본문색인 후보 등록", "PDF 첫 페이지 텍스트 추출 결과에서 추정");
            if (tags.length > 0) {
                this.addCandidate("aiSubjectKeywords", "태그 후보", tags.join(", "), "파일명/PDF 텍스트 규칙 기반 추정");
                this.mergeTagCandidates(tags);
            }

            this.fillPublicationInfoCandidate("PDF");
            this.form.bibliographicCandidate = this.buildBibliographicCandidateSummary();
            this.form.autoAnalysisNotes = "자동 생성 후보는 확정 서지정보가 아니며 담당자 검수 후 저장합니다.";
            this.addCandidate("pdfMetadata", "PDF 메타데이터", this.form.pdfMetadataAnalysis, "PDF 메타데이터에서 추출", false);
            this.addCandidate("pdfProducer", "PDF 생성 도구", metaProducer, "PDF 메타데이터 Producer에서 추출", false);
        } catch (e) {
            if (revision === this.pdfAnalysisRevision && this.pendingFile === file) {
                this.analysisErrorMessage = `PDF 자동 분석에 실패했습니다. 수동 입력은 계속 가능합니다. (${this.text(e) || "분석 오류"})`;
            }
        } finally {
            if (pdf && pdf.destroy) {
                try { await pdf.destroy(); } catch (e) { }
            }
            if (revision === this.pdfAnalysisRevision) this.analyzingPdf = false;
            await this.service.render();
        }
    }

    private applyUrlAnalysisResult(result: UrlAnalysisResult, inputUrl: string) {
        let statusLabel = result.accessible ? `접근 가능 (${result.statusCode || 200})` : `접근 실패 (${result.statusCode || "확인 필요"})`;
        this.addCandidate("urlAccessStatus", "URL 접근 가능 여부", statusLabel, "URL 접근 결과", false);
        this.addCandidate("externalViewUrl", "외부 열람 URL", result.finalUrl || inputUrl, "URL 최종 접근 주소에서 추출");
        this.addCandidate("sourceLink", "원본 링크", result.originalLink || result.finalUrl || inputUrl, "canonical/최종 URL에서 추출");

        (result.candidates || []).forEach((candidate: AutoDraftCandidate) => {
            this.addCandidate(candidate.field, candidate.label, candidate.value, candidate.source);
        });

        let pdfLinks = Array.isArray(result.pdfLinks) ? result.pdfLinks : [];
        let coverImages = Array.isArray(result.coverImages) ? result.coverImages : [];
        let metaRows = Array.isArray(result.metadataCandidates) ? result.metadataCandidates : [];
        if (pdfLinks.length > 0) {
            this.addCandidate("originalUrl", "원문 URL 후보", this.text(pdfLinks[0].url), "HTML PDF 링크에서 추출");
            this.addCandidate("storageStatus", "원문DB 상태 후보", "원문 링크 등록", "HTML PDF 링크에서 추정");
            this.addCandidate("downloadablePdfLinks", "다운로드 가능한 PDF 링크 후보", pdfLinks.map((item) => item.url).join("\n"), "HTML 링크에서 추출", false);
        }
        if (coverImages.length > 0) {
            this.addCandidate("coverCandidate", "표지 이미지 후보", coverImages[0].url, coverImages[0].source || "HTML 이미지에서 추출");
        }
        if (metaRows.length > 0) {
            this.addCandidate("htmlMetadata", "HTML 내 메타데이터 후보", metaRows.map((item) => `${item.label}: ${item.value}`).join("\n"), "HTML 메타데이터에서 추출", false);
        }
        let tagSource = [
            result.pageTitle,
            (metaRows || []).map((item) => item.value).join(" "),
            (pdfLinks || []).map((item) => item.url).join(" "),
        ].join(" ");
        let tags = this.inferTags(tagSource);
        if (tags.length > 0) {
            this.addCandidate("aiSubjectKeywords", "태그 후보", tags.join(", "), "URL 제목/HTML 메타데이터 규칙 기반 추정");
            this.mergeTagCandidates(tags);
        }
        this.fillPublicationInfoCandidate("URL");
        this.form.bibliographicCandidate = this.buildBibliographicCandidateSummary();
        this.form.autoAnalysisNotes = "URL 분석 후보는 접근 시점의 HTML 정보이며 담당자 검수 전 확정값으로 사용하지 않습니다.";
    }

    private addCandidate(field: string, label: string, value: any, source: string, apply: boolean = false) {
        value = this.text(value);
        if (!value) return;
        let normalizedSource = this.text(source).toLowerCase();
        let sourceKind = /pdf|파일명|업로드 파일|첫 페이지|본문/.test(normalizedSource) ? "pdf" : (/url|html|canonical|웹페이지/.test(normalizedSource) ? "url" : "");
        let sourceKey = sourceKind === "pdf" ? this.lastPdfSourceKey : (sourceKind === "url" ? this.lastUrlSourceKey : "");
        let existing = this.form.autoDraftCandidates.find((item) => !item.stale && item.field === field && item.value === value && item.source === source && (item.sourceKey || "") === sourceKey);
        let candidate = existing || { field, label, value, source, status: "미확인", applied: false, reviewValue: value, sourceKind, sourceKey, stale: false };
        if (!existing) this.form.autoDraftCandidates.push(candidate);
        candidate.status = this.normalizeCandidateStatus(candidate.status);
        if (!this.text(candidate.reviewValue)) candidate.reviewValue = value;
        if (apply) {
            this.applyCandidateReviewValue(candidate, "자동 적용");
        }
    }

    private retireCandidates(sourceKind: string) {
        (this.form.autoDraftCandidates || []).forEach((candidate) => {
            if (candidate.sourceKind === sourceKind) {
                candidate.stale = true;
                candidate.applied = false;
            }
        });
    }

    private applyCandidateReviewValue(candidate: AutoDraftCandidate, action: string): boolean {
        if (!candidate || !this.candidateCanApply(candidate)) return false;
        let reviewValue = this.candidateReviewValue(candidate);
        if (!reviewValue && action !== "비우기") return false;
        if (!this.applyCandidateToForm(candidate, true, reviewValue)) return false;
        candidate.reviewValue = reviewValue;
        candidate.applied = true;
        candidate.status = this.text(candidate.value) === reviewValue ? "적용" : "수정됨";
        candidate.updatedAt = this.nowStamp();
        this.logCandidateChange(candidate, action, reviewValue);
        this.form.bibliographicCandidate = this.buildBibliographicCandidateSummary();
        return true;
    }

    private applyCandidateToForm(candidate: AutoDraftCandidate, overwrite: boolean, nextValue?: string): boolean {
        let field = this.confirmedFieldForCandidate(candidate.field);
        let value = this.text(nextValue === undefined ? candidate.value : nextValue);
        if (!value) return false;
        if (field === "confirmedSubjectKeywords") {
            this.mergeConfirmedTagCandidates(value.split(/[,\n]/).map((item) => this.text(item)).filter((item) => !!item));
            return true;
        }
        if (!Object.prototype.hasOwnProperty.call(this.form, field)) return false;
        let current = this.text((this.form as any)[field]);
        if (!overwrite && current) return false;
        (this.form as any)[field] = value;
        return true;
    }

    private confirmedFieldForCandidate(field: string): string {
        if (field === "aiSubjectKeywords") return "confirmedSubjectKeywords";
        if (field === "coverCandidate") return "confirmedCover";
        return field;
    }

    private normalizeCandidateStatus(value: any): string {
        let status = this.text(value).replace(/\s+/g, "");
        if (status === "적용") return "적용";
        if (status === "수정됨" || status === "수정") return "수정됨";
        if (status === "반려") return "반려";
        return "미확인";
    }

    private logCandidateChange(candidate: AutoDraftCandidate, action: string, value: string) {
        let fieldLabel = this.candidateFieldLabel(candidate.field);
        let sourceLabel = this.candidateSourceType(candidate);
        let preview = this.candidateValuePreview(value || "비움");
        let line = `${this.nowStamp()} · ${fieldLabel} · ${action} · ${sourceLabel} · ${preview}`;
        this.form.candidateChangeLog = [line, ...(this.form.candidateChangeLog || [])].slice(0, 50);
    }

    private nowStamp(): string {
        return new Date().toISOString().slice(0, 19).replace("T", " ");
    }

    private mergeTagCandidates(tags: string[]) {
        let current = this.form.aiSubjectKeywords
            .split(/[\n,]/)
            .map((item) => this.text(item))
            .filter((item) => !!item);
        tags.forEach((tag) => {
            if (tag && !current.includes(tag)) current.push(tag);
        });
        this.form.aiSubjectKeywords = current.slice(0, 20).join("\n");
    }

    private mergeConfirmedTagCandidates(tags: string[]) {
        let current = this.form.confirmedSubjectKeywords
            .split(/[\n,]/)
            .map((item) => this.text(item))
            .filter((item) => !!item);
        tags.forEach((tag) => {
            if (tag && !current.includes(tag)) current.push(tag);
        });
        this.form.confirmedSubjectKeywords = current.slice(0, 20).join("\n");
    }

    private fillPublicationInfoCandidate(sourceKind: string = "") {
        let publisher = this.text(this.form.publisher) || this.latestCandidateValue("publisher");
        let year = this.text(this.form.publishedYear) || this.latestCandidateValue("publishedYear");
        if (!this.text(this.form.publicationInfo) && (publisher || year)) {
            this.addCandidate("publicationInfo", "발행정보 후보", [publisher, year].filter((item) => !!item).join(", "), `${sourceKind || "자동"} 발행기관/발행연도 후보에서 조합`);
        }
    }

    private latestCandidateValue(field: string): string {
        let rows = this.currentCandidates().filter((candidate) => candidate.field === field && this.candidateStatusLabel(candidate) !== "반려");
        if (rows.length === 0) return "";
        return this.candidateReviewValue(rows[rows.length - 1]);
    }

    private buildBibliographicCandidateSummary(): string {
        let lines = this.currentCandidates()
            .filter((item) => ["title", "publisher", "publishedYear", "contributor", "isbn", "issn", "materialType", "originalUrl", "fulltextPossession", "textExtractionStatus", "coverCandidate", "aiSubjectKeywords"].includes(item.field))
            .map((item) => `- ${item.label}: ${item.value} (${this.candidateSourceType(item)} · ${this.candidateStatusLabel(item)})`);
        return lines.slice(0, 20).join("\n");
    }

    private async ensurePdfjs() {
        if (this.pdfjs) return this.pdfjs;
        let lib: any = pdfjsLib;
        lib.GlobalWorkerOptions.workerSrc = "/wiz/api/page.admin.materials.new/pdfworker";
        this.pdfjs = lib;
        return this.pdfjs;
    }

    private async extractPdfTextSample(pdf: any, pageLimit: number): Promise<string> {
        let rows: string[] = [];
        for (let pageNumber = 1; pageNumber <= pageLimit; pageNumber++) {
            try {
                let page = await pdf.getPage(pageNumber);
                let content = await page.getTextContent();
                let text = (content.items || [])
                    .map((item: any) => this.text(item.str))
                    .filter((item: string) => !!item)
                    .join(" ")
                    .replace(/\s+/g, " ")
                    .trim();
                if (text) rows.push(text);
            } catch (e) { }
        }
        return rows.join(" ").slice(0, 6000);
    }

    private async renderCoverPreview(pdf: any): Promise<string> {
        try {
            let page = await pdf.getPage(1);
            let baseViewport = page.getViewport({ scale: 1 });
            let scale = Math.min(1.2, 320 / Math.max(1, baseViewport.width));
            let viewport = page.getViewport({ scale });
            let canvas = document.createElement("canvas");
            canvas.width = Math.floor(viewport.width);
            canvas.height = Math.floor(viewport.height);
            let context = canvas.getContext("2d");
            if (!context) return "";
            await page.render({ canvasContext: context, viewport }).promise;
            return canvas.toDataURL("image/jpeg", 0.72);
        } catch (e) {
            return "";
        }
    }

    private pdfMetadataSummary(info: any): string {
        let rows = [
            ["Title", this.normalizePdfMetaValue(info.Title)],
            ["Author", this.normalizePdfMetaValue(info.Author)],
            ["Subject", this.normalizePdfMetaValue(info.Subject)],
            ["Creator", this.normalizePdfMetaValue(info.Creator)],
            ["Producer", this.normalizePdfMetaValue(info.Producer)],
            ["CreationDate", this.normalizePdfMetaValue(info.CreationDate)],
            ["ModDate", this.normalizePdfMetaValue(info.ModDate)],
        ].filter((row) => this.text(row[1]));
        if (rows.length === 0) return "PDF 메타데이터 없음 또는 확인 필요";
        return rows.map((row) => `${row[0]}=${row[1]}`).join(" · ");
    }

    private normalizePdfMetaValue(value: any): string {
        return this.text(value).replace(/^D:/, "").replace(/\u0000/g, "").trim();
    }

    private humanFileSize(size: number): string {
        size = Number(size || 0);
        if (size < 1024) return `${size} B`;
        if (size < 1024 * 1024) return `${Math.round(size / 1024)} KB`;
        return `${(size / 1024 / 1024).toFixed(1)} MB`;
    }

    private titleFromFilename(name: string): string {
        let title = this.text(name)
            .replace(/\.[^.]+$/, "")
            .replace(/\[[^\]]+\]/g, "")
            .replace(/[_]+/g, " ")
            .replace(/\s+/g, " ")
            .trim();
        return title;
    }

    private extractYear(value: string): string {
        let match = this.text(value).match(/(?:19|20)\d{2}/);
        return match ? match[0] : "";
    }

    private extractIsbn(value: string): string {
        let match = this.text(value).match(/ISBN(?:-1[03])?\s*[:：]?\s*([0-9][0-9\-\s]{8,20}[0-9Xx])/i);
        return match ? match[1].replace(/\s+/g, "") : "";
    }

    private extractIssn(value: string): string {
        let match = this.text(value).match(/ISSN\s*[:：]?\s*(\d{4}[-\s]?\d{3}[\dXx])/i);
        return match ? match[1].replace(/\s+/g, "") : "";
    }

    private publisherFromText(value: string): string {
        let text = this.text(value);
        if (/동북아역사재단|Northeast Asian History Foundation/i.test(text)) return "동북아역사재단";
        return "";
    }

    private inferMaterialType(value: string): string {
        let text = this.text(value);
        if (/발굴|조사\s*보고서|보고서|리포트/i.test(text)) return "보고서";
        if (/교육|교사용|학습지|바로\s*알기|안내서/i.test(text)) return "교육자료";
        if (/외교문서|회담|교섭/i.test(text)) return "외교문서";
        if (/사료|자료집|역주|국역|번역/i.test(text)) return "사료집";
        if (/논문|논총|학술지/i.test(text)) return "학술논문";
        return "간행도서";
    }

    private inferTags(value: string): string[] {
        let text = this.text(value).toLowerCase();
        let rules = [
            { words: ["독도", "울릉도", "동해", "영유권", "takeshima", "liancourt"], tags: ["독도", "독도·동해 표기 연구", "영토·영유권"] },
            { words: ["위안부", "위안소", "성노예"], tags: ["일본군 위안부", "한일 역사문제 연구", "일제강점기"] },
            { words: ["강제동원", "징용", "전시동원"], tags: ["강제동원", "한일 역사문제 연구", "일제강점기"] },
            { words: ["한일회담", "청구권", "외교문서"], tags: ["한일회담·청구권", "한일관계사", "외교문서"] },
            { words: ["고구려", "광개토", "고구려비", "산성"], tags: ["고구려사", "한국 고중세사 연구"] },
            { words: ["발해", "크라스키노", "연해주"], tags: ["발해사", "발해 유적·고고학", "한국 고중세사 연구"] },
            { words: ["동북공정", "중국 역사", "중국 교과서"], tags: ["동북공정", "한중관계사 연구"] },
            { words: ["간도", "백두산정계비", "압록강", "두만강"], tags: ["간도·국경", "한중관계사 연구", "개항기·대한제국"] },
            { words: ["발굴", "고고학", "유적"], tags: ["발굴조사보고서"] },
            { words: ["교육", "교사용", "학습지"], tags: ["교육자료", "역사인식 교육·홍보"] },
        ];
        let tags: string[] = [];
        rules.forEach((rule) => {
            if (rule.words.some((word) => text.includes(word.toLowerCase()))) {
                rule.tags.forEach((tag) => {
                    if (!tags.includes(tag)) tags.push(tag);
                });
            }
        });
        return tags.slice(0, 20);
    }
}

export default PageAdminMaterialsNewComponent;